import { isFuture } from 'date-fns';
import { LoadingState } from '../types';
/**
 * Check if an item has been successfully loaded and hasn't expired.
 */
export const isFetchedDataValid = (fetchedData) => {
    if ((fetchedData === null || fetchedData === void 0 ? void 0 : fetchedData.loadingState) !== LoadingState.Success)
        return false;
    return isFuture(new Date(fetchedData.expiresAt));
};
//# sourceMappingURL=is-fetched-data-valid.js.map